import { render, staticRenderFns } from "./newViewonline.vue?vue&type=template&id=1388d37f&scoped=true"
import script from "./newViewonline.vue?vue&type=script&lang=js"
export * from "./newViewonline.vue?vue&type=script&lang=js"
import style0 from "./newViewonline.vue?vue&type=style&index=0&id=1388d37f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388d37f",
  null
  
)

export default component.exports